import React, { Component } from 'react';

class Footer extends Component {
  render() {

    if(this.props.data){
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">
           <ul className="social-links">
              {networks}
           </ul>
          <ul>
            <div style={{color:'saddlebrown'}}>
              Vistor's Count
            </div>
            <img src="https://counter2.stat.ovh/private/freecounterstat.php?c=khfg2k8m3h4wnblexuawsq2d9rdzyqru" border="0" title="website counters" alt="website counters"></img>
          </ul>
           <ul>
            <li> With love ♥ from Tech Lover ️</li>
           </ul>

           <ul className="copyright">
              <li>&copy; Copyright  2022 Shubham Shankar</li>
              <li>Design by <a title="Shubham LinkedIn" href="https://www.linkedin.com/in/shubhamshankar/" target = "_blank">Shubham Shankar</a></li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
  }
}

export default Footer;
